import React from 'react';
import Helmet from 'react-helmet';

function Seo({ description, lang = 'en', meta = [], keywords = [], title, canonical = true, ...props }) {
	const metaDescription = description || props.ogDescription;
	if (props.metaRobotsNofollow === "follow") {
		props.metaRobotsNofollow += ", max-snippet:-1, max-image preview:large, max-video-preview:-1";
	}

	title = title
				?.replace(/2021|2022|2023/g, "2024")
				?.replace(/robot lawyer/gi, "AI Consumer Champion")
				?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
				.trim();

	if (props.seoTitle) {
		props.seoTitle = props.seoTitle
									?.replace(/2021|2022|2023/g, "2024")
									?.replace(/robot lawyer/gi, "AI Consumer Champion")
									?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
									.trim();
	}

	if (props.ogTitle) {
		props.ogTitle = props.ogTitle
								?.replace(/2021|2022|2023/g, "2024")
								?.replace(/robot lawyer/gi, "AI Consumer Champion")
								?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
								.trim();
	}

	if (props.ogDescription) {
		props.ogDescription = props.ogDescription
											?.replace(/2021|2022|2023/g, "2024")
											?.replace(/robot lawyer/gi, "AI Consumer Champion")
											?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
											.trim();
	}

	const directRoutes = ["terms-of-service", "privacy-policy"];

	let canonicalSlug = props.slug === 'main' ? 'https://arefund.com/' :
	directRoutes.includes(props.slug) ? 'https://arefund.com/' + props.slug + "/" :
		props.slug === 'learn' ? 'https://arefund.com/learn/' :
		'https://arefund.com/learn/' + props.slug + "/";
		
	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={props.seoTitle ? props.seoTitle : title}
			titleTemplate={`%s`}
			meta={[
				metaDescription
					? {
						name: `description`,
						content: metaDescription,
					}
					: {},
				props.metaRobotsNofollow && props.metaRobotsNoindex
					? {
						name: `robots`,
						content: props.metaRobotsNoindex + ', ' + props.metaRobotsNofollow,
					}
					: props.metaRobotsNofollow
						? {
							name: `robots`,
							content: props.metaRobotsNofollow,
						}
						: props.metaRobotsNoindex
							? {
								name: `robots`,
								content: props.metaRobotsNoindex,
							}
							: {},
				props.ogTitle
					? {
						property: `og:title`,
						content: props.ogTitle,
					}
					: {},
				props.ogDescription
					? {
						property: `og:description`,
						content: props.ogDescription,
					}
					: {},
				props.ogType
					? {
						property: `og:type`,
						content: props.ogType,
					}
					: {},
				props.ogSiteName
					? {
						property: `og:site_name`,
						content: props.ogSiteName,
					}
					: {},
				{
					property: `og:image`,
					content: "https://arefund.com/socialCard.png",
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},

				title
					? {
						name: `twitter:title`,
						content: title,
					}
					: {},
					{
						property: `og:url`,
						content: canonicalSlug,
					},
				metaDescription
					? {
						name: `twitter:description`,
						content: metaDescription,
					}
					: {},
			]
				.concat(
					keywords.length > 0
						? {
							name: `keywords`,
							content: keywords.join(`, `),
						}
						: [],
				)
				.concat(meta)}


		>

			<link
				rel="icon"
				href={"https://arefund.com/refund_logo.png"}
				type="image/icon type"
			></link>
			{canonical && (
				<link
					rel="canonical"
					href={
						canonicalSlug
					}
				/>
			)}
		</Helmet>
	);
}

export default React.memo(Seo);
